import { useCallback } from "react"
import { Box, SxProps } from "@mui/material"
import { useNavigate } from "react-router-dom"

import { Carousel, CarouselItem } from "components/Carousel"
import { VerticalEventCard } from "components/domains/events"
import { IFeature } from "interfaces"
import { IExtendOptions } from "components/Carousel/Carousel"

const DEFAULT_SLIDE_PER_PAGE = 3

interface IFeatureCarouselLayoutProps {
  sx?: SxProps
  features: IFeature[]
  carouselOption?: IExtendOptions
  carouselSx?: SxProps
  linkPrefix?: string
}

export const FeatureCarouselLayout = ({
  sx,
  features,
  carouselOption,
  carouselSx,
  linkPrefix = "/events",
}: IFeatureCarouselLayoutProps) => {
  const navigate = useNavigate()

  const carouselType =
    features && features.length < DEFAULT_SLIDE_PER_PAGE ? "slide" : "loop"

  const autoplay = features && features.length > DEFAULT_SLIDE_PER_PAGE

  const handleClickSlide = useCallback(
    (_splide, { slide }) => {
      navigate(slide.getAttribute("link"))
    },
    [navigate]
  )

  return (
    <Box sx={sx}>
      <Carousel
        onClick={handleClickSlide}
        options={{
          type: carouselType,
          pagination: true,
          focus: "center",
          trimSpace: false,
          autoplay,
          padding: 0,
          perPage: DEFAULT_SLIDE_PER_PAGE,
          drag: features.length > 1,
          ...carouselOption,
        }}
        sx={carouselSx}
      >
        {features.map((feature) => {
          const sponsoredId = feature?.properties?.sponsoredId

          return (
            <CarouselItem
              link={`${linkPrefix}/${feature.id}`}
              key={`${sponsoredId || ""}${feature.id}`}
            >
              <VerticalEventCard event={feature} />
            </CarouselItem>
          )
        })}
      </Carousel>
    </Box>
  )
}
